export enum IvaConditionCode {
  RESPONSABLE_INSCRIPTO = '1',
  NO_ALCANZADO = '3',
  EXENTO = '4',
  CONSUMIDOR_FINAL = '5',
  RESPONSABLE_MONOTRIBUTO = '6',
  SUJETO_NO_CATEGORIZADO = '7',
}

export const IVA_CONDITION_CODE_META: Record<
  IvaConditionCode,
  { descripcion: string; descripcionAbreviada: string }
> = {
  [IvaConditionCode.RESPONSABLE_INSCRIPTO]: {
    descripcion: 'RESPONSABLE INSCRIPTO',
    descripcionAbreviada: 'RI',
  },
  [IvaConditionCode.NO_ALCANZADO]: {
    descripcion: 'NO ALCANZADO',
    descripcionAbreviada: 'NR',
  },
  [IvaConditionCode.EXENTO]: {
    descripcion: 'EXENTO',
    descripcionAbreviada: 'EXE',
  },
  [IvaConditionCode.CONSUMIDOR_FINAL]: {
    descripcion: 'CONSUMIDOR FINAL',
    descripcionAbreviada: 'CF',
  },
  [IvaConditionCode.RESPONSABLE_MONOTRIBUTO]: {
    descripcion: 'RESPONSABLE MONOTRIBUTO',
    descripcionAbreviada: 'MON',
  },
  [IvaConditionCode.SUJETO_NO_CATEGORIZADO]: {
    descripcion: 'SUJETO NO CATEGORIZADO',
    descripcionAbreviada: 'NOC',
  },
};

export function isConsumidorFinalIvaCode(code: unknown): boolean {
  return String(code ?? '') === IvaConditionCode.CONSUMIDOR_FINAL;
}
